import { Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import SectionLabel from '../components/SectionLabel';
import { langFromPath } from '../i18n/routes';

const COPY = {
  nl: {
    label: 'Pagina niet gevonden',
    title: 'Deze pagina bestaat niet (meer).',
    text: 'De link is mogelijk verouderd of verkeerd getypt. Gebruik onderstaande links om verder te gaan.',
    home: 'Naar de homepage',
    links: [
      { to: '/diensten', label: 'Diensten' },
      { to: '/prijzenlijst', label: 'Prijzen' },
      { to: '/detailing-aan-huis', label: 'Detailing aan huis' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  en: {
    label: 'Page not found',
    title: 'This page does not exist.',
    text: 'The link may be outdated or mistyped. Use the links below to continue.',
    home: 'Back to homepage',
    links: [
      { to: '/en/services', label: 'Services' },
      { to: '/en/pricing', label: 'Pricing' },
      { to: '/en/mobile-detailing', label: 'Mobile detailing' },
      { to: '/en/contact', label: 'Contact' },
    ],
  },
};

const NotFound = () => {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  const t = COPY[lang] || COPY.nl;
  const homeTo = lang === 'en' ? '/en' : '/';

  return (
    <div className="bg-[#0a0a0b] text-white min-h-[70vh] flex items-center" data-testid="notfound-page">
      <SEO path={pathname} title={t.label} noindex />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-32 w-full">
        <SectionLabel>{t.label}</SectionLabel>
        <div className="mt-6 text-[#2f6bff] text-7xl md:text-9xl font-medium tracking-tight">404</div>
        <h1 className="mt-4 text-4xl md:text-6xl font-medium tracking-tight leading-[1.05] max-w-3xl">{t.title}</h1>
        <p className="mt-6 text-white/60 text-lg max-w-xl leading-relaxed">{t.text}</p>
        <Link
          to={homeTo}
          data-testid="notfound-home-link"
          className="mt-10 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#2f6bff] hover:bg-[#1f56e8] text-white text-sm transition-colors"
        >
          <HomeIcon className="w-4 h-4" /> {t.home}
        </Link>
        <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {t.links.map((l) => (
            <Link key={l.to} to={l.to} className="text-[#7aa3ff] hover:text-white transition-colors inline-flex items-center gap-1.5">
              {l.label} <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
